// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_1l-2";
export var blackBorderOnHover = "_1l-7";
export var cell = "_1l-6";
export var cellContainer = "_1l-3";
export var checked = "_1l-8";
export var disabled = "_1l-5";
export var featuredIconCellContainer = "_1l-9";
export var featuredIconTextContainer = "_1l-b";
export var featuredIconWrapper = "_1l-a";
export var noBorder = "_1l-c";
export var orangeSelectedRow = "_4e-3";
export var overflowableText = "_1l-0";
export var overflowableTextContainer = "_1l-1";
export var row = "_1m-0";
export var rowCheckboxCell = "_1l-4";
export var selectableTable = "_4e-2";